(() => {
  'use strict';
  if (window.__alpeAnalyticsReady) return;
  window.__alpeAnalyticsReady = true;
  const configNode = document.getElementById('AlpeAnalyticsConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  let started = false;
  let scheduled = false;
  let privacy;

  const allowed = () => privacy && privacy.currentVisitorConsent().analytics === 'yes' && privacy.analyticsProcessingAllowed();
  const clarityConsent = () => ({
    analytics_Storage: allowed() ? 'granted' : 'denied',
    ad_Storage: privacy.currentVisitorConsent().marketing === 'yes' && privacy.marketingAllowed() ? 'granted' : 'denied'
  });
  const load = (src, onload) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (onload) script.addEventListener('load', onload, {once: true});
    document.head.appendChild(script);
  };
  const start = () => {
    scheduled = false;
    if (started || !allowed()) return;
    started = true;
    if (config.recorder === 'clarity') {
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('consentv2', clarityConsent());
      load('https://www.clarity.ms/tag/xy68ns6vq3');
    } else if (config.recorder === 'hotjar') {
      window.hj = window.hj || function () { (window.hj.q = window.hj.q || []).push(arguments); };
      window._hjSettings = {hjid: 3518783, hjsv: 6};
      load('https://static.hotjar.com/c/hotjar-3518783.js?sv=6');
    }
    if (config.metricool) {
      load('https://tracker.metricool.com/resources/be.js', () => {
        if (allowed() && window.beTracker) window.beTracker.t({hash: '479ebbf88ee59e21f9acf2a3d8c45c8b'});
      });
    }
  };
  const sync = () => {
    if (!privacy) return;
    if (started && !allowed()) {
      // Unload third-party listeners when analytics consent is withdrawn.
      if (window.clarity && config.recorder === 'clarity') window.clarity('consentv2', clarityConsent());
      window.location.reload();
      return;
    }
    if (started && window.clarity && config.recorder === 'clarity') window.clarity('consentv2', clarityConsent());
    if (started || scheduled || !allowed()) return;
    scheduled = true;
    const idle = () => window.requestIdleCallback ? window.requestIdleCallback(start, {timeout: 2000}) : window.setTimeout(start, 250);
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, {once: true});
  };
  document.addEventListener('visitorConsentCollected', sync);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (error || !window.Shopify.customerPrivacy) return;
      privacy = window.Shopify.customerPrivacy;
      sync();
    });
  }
})();
